"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.function.name");
var _activityPop = _interopRequireDefault(require("./components/activityPop.vue"));
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomizePageManagement',
  components: {
    customizePagePopup: _activityPop.default
  },
  data: function data() {
    return {
      page: 1,
      size: 10,
      total: 1,
      title: '',
      tableList: []
    };
  },
  created: function created() {
    this.findList();
  },
  methods: {
    reset: function reset() {
      this.title = '';
      this.page = 1;
      this.findList();
    },
    search: function search() {
      this.page = 1;
      this.findList();
    },
    findList: function findList() {
      var _this = this;
      (0, _customPage.getList)({
        page: this.page,
        size: this.size,
        name: this.title
      }).then(function (res) {
        _this.tableList = res.data.data;
        _this.total = res.data.total;
      });
    },
    goRenovation: function goRenovation(val) {
      this.$router.push({
        path: '/operationManagement/renovation',
        query: {
          activityName: val.name,
          id: val.pageId
        }
      });
    },
    onRefresh: function onRefresh(val) {
      if (val === 'add') {
        this.page = 1;
      }
      this.findList();
    },
    onAdd: function onAdd() {
      this.$refs.customizePagePopup.open({
        type: 'add',
        title: '自定义页面添加'
      });
    },
    del: function del(val) {
      var _this2 = this;
      this.$confirm('是否确认删除此自定义页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deletePage)({
          pageId: val.pageId
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this2.findList();
          }
        });
        // this.pageDeletePage(data.id)
      });
    },
    detail: function detail(val) {
      this.$refs.customizePagePopup.open({
        type: 'upDate',
        name: val.name,
        id: val.pageId,
        remark: val.remark,
        title: '自定义页面详情'
      });
    },
    copy: function copy(val) {
      var _this3 = this;
      (0, _customPage.getLink)({
        pageId: val.pageId
      }).then(function (res) {
        try {
          _this3.$copyText(res.data.toString()).then(function () {
            _this3.$notify.success({
              title: '温馨提示',
              message: '拷贝成功'
            });
          }).catch(function () {
            _this3.$notify.success({
              title: '温馨提示',
              message: '拷贝失败，请手动复制'
            });
          });
        } catch (err) {
          _this3.$notify.error({
            title: '温馨提示',
            message: '拷贝失败，请手动复制'
          });
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.findList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.findList();
    }
  }
};